import { render } from "./ElectionVoteBallotView.vue?vue&type=template&id=1697c6c8&scoped=true"
import script from "./ElectionVoteBallotView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteBallotView.vue?vue&type=script&lang=js"

import "./ElectionVoteBallotView.vue?vue&type=style&index=0&id=1697c6c8&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1697c6c8"]])

export default __exports__